var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoAgregarMiembro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 64,
    viewBox: "0 0 80 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.875 40C47.125 40 52.875 34.25 52.875 27C52.875 19.875 47 14 39.875 14C32.75 14 27 19.875 27 27C26.875 34.25 32.75 40 39.875 40ZM46.125 44H33.75C23.875 44 16 51.5 16 60.75C16 62.625 17.5 64 19.5 64H60.375C62.375 64 64 62.625 64 60.75C64 51.5 56 44 46.125 44ZM64 20C69.5 20 74 15.625 74 10C74 4.5 69.5 0 64 0C58.375 0 54 4.5 54 10C54 15.625 58.375 20 64 20ZM22.875 27C22.875 26.375 23 25.75 23.125 25.125C21.75 24.375 20.25 24 18.625 24H11C4.875 24 0 29.25 0 35.75C0 37 0.875 38 2.125 38H27.125C24.5 35.125 22.875 31.25 22.875 27ZM16 20C21.5 20 26 15.625 26 10C26 4.5 21.5 0 16 0C10.375 0 6 4.5 6 10C6 15.625 10.375 20 16 20ZM68.875 24H61.25C59.625 24 58.125 24.5 56.75 25.125C56.75 25.75 56.875 26.375 56.875 27C56.875 31.25 55.375 35.125 52.75 38H77.75C79 38 80 37 80 35.75C80 29.25 75 24 68.875 24Z",
    fill: "#F0F0EE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoAgregarMiembro);
export default __webpack_public_path__ + "static/media/icono_agregarMiembro.ff995869ad4e47d9ddb17a3390f9f7e8.svg";
export { ForwardRef as ReactComponent };